import gql from 'graphql-tag';

// Mobile-lean selections for the My account section. List/acknowledge flows reuse the
// shared operations in src/common/graphql/people where their fragments fit; the queries
// below avoid the heavy people-app fragments (action summaries, related events, etc.).

export const GET_MY_EMPLOYEE_PROFILE_MOBILE = gql`
	query getMyEmployeeProfileMobile {
		getMyEmployeeProfile {
			id
			firstName
			lastName
			preferredName
			personalEmail
			workEmail
			phoneNumber
			position {
				id
				name
			}
			team
			employmentType
			startDate
			originalStartDate
			probationEndDate
			workTenant {
				id
				name
			}
			workTenantRole {
				id
				name
			}
			managerEmployee {
				id
				firstName
				lastName
				preferredName
			}
			hoursPerWeek
			workDays
			awardName
			salary
			pay
			positionDescriptionDocument {
				id
				title
				format
				contentHtml
				s3Key
				templateConfig
				formConfig
				version
			}
		}
	}
`;

// Profile photo and get to know you answers, shown on Sentry People and Sentry Chat profiles.
export const GET_MY_PROFILE_ABOUT_YOU_MOBILE = gql`
	query getMyProfileAboutYouMobile {
		getMyEmployeeProfile {
			id
			firstName
			lastName
			preferredName
			profilePhotoUrl
			profilePrompts
		}
	}
`;

// The photo is saved on the linked user, so its avatar refreshes in the app too.
export const MODIFY_MY_PROFILE_ABOUT_YOU_MOBILE = gql`
	mutation modifyMyProfileAboutYouMobile($input: ModifyEmployeeInput!) {
		modifyEmployee(input: $input) {
			employee {
				id
				profilePhotoUrl
				profilePrompts
				user {
					id
					profilePhotoUrl
				}
			}
		}
	}
`;

const MOBILE_EMPLOYEE_WARNING_FRAGMENT = gql`
	fragment mobileEmployeeWarning on EmployeeWarning {
		id
		type
		typeLabel
		status
		statusLabel
		issuedAt
		summary
		details
		contentHtml
		acknowledged
		acknowledgedAt
		issuedBy {
			id
			firstname
			lastname
		}
		created
	}
`;

export const GET_MY_WARNINGS = gql`
	query getMyWarnings(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: EmployeeWarningFilter
	) {
		getEmployeeWarnings(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...mobileEmployeeWarning
			}
			count
		}
	}
	${MOBILE_EMPLOYEE_WARNING_FRAGMENT}
`;

export const COUNT_MY_WARNINGS = gql`
	query countMyWarnings($filter: EmployeeWarningFilter) {
		countEmployeeWarnings(filter: $filter)
	}
`;

export const ACKNOWLEDGE_MY_WARNING = gql`
	mutation acknowledgeMyWarning($id: ID!) {
		acknowledgeEmployeeWarning(id: $id) {
			...mobileEmployeeWarning
		}
	}
	${MOBILE_EMPLOYEE_WARNING_FRAGMENT}
`;

export const ACKNOWLEDGE_COMPANY_DOCUMENT_MOBILE = gql`
	mutation acknowledgeCompanyDocumentMobile($input: AcknowledgeCompanyDocumentInput!) {
		acknowledgeCompanyDocument(input: $input) {
			id
			acknowledgedAt
		}
	}
`;

export const CREATE_EMPLOYEE_DOCUMENT_RECORD_MOBILE = gql`
	mutation createEmployeeDocumentRecordMobile($input: CreateEmployeeDocumentRecordInput!) {
		createEmployeeDocumentRecord(input: $input) {
			id
		}
	}
`;

export const GET_EMPLOYEE_DOCUMENT_TYPES_MOBILE = gql`
	query getEmployeeDocumentTypesMobile(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!
	) {
		getEmployeeDocuments(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection
		) {
			items {
				id
				name
				settings
			}
		}
	}
`;

export const GET_MY_EMPLOYEE_DOCUMENT_RECORDS_MOBILE = gql`
	query getMyEmployeeDocumentRecordsMobile(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!
	) {
		getEmployeeDocumentRecords(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection
		) {
			items {
				id
				created
				title
				category
				expiresAt
				documentType {
					id
					name
				}
			}
		}
	}
`;
